import { t } from "../services/utils";
export default {
  TEXT: 0,
  IMAGE: 1,
  VIDEO: 2,
  AUDIO: 3,
  OTHER: 4
};